export function associateShipmentsWithItems(order: any) {
  const { orderItems, orderShipments } = order;

  // shipmentLineNo - orderShipments
  const shipmentMap = orderShipments.reduce((map: any, shipment: any) => {
    map[shipment.shipmentLineNo] = shipment;
    return map;
  }, {});

  // add shipment to orderItem by shipmentLineNo
  const itemsWithShipment = orderItems.map((item: any) => {
    const associatedShipment = shipmentMap[item.shipmentLineNo] || null;
    return {
      ...item,
      orderId: order.orderId,
      orderShipment: associatedShipment,
    };
  });

  return itemsWithShipment;
}
